import { toast as sonnerToast, Toaster } from "sonner";

export function ToastProvider() {
  return (
    <Toaster
      position="top-right"
      toastOptions={{
        duration: 5000,
        style: {
          background: "var(--glass-bg)",
          border: "1px solid var(--glass-border)",
          backdropFilter: "var(--glass-blur)",
          color: "var(--color-text)",
          fontFamily: "var(--font-mono)",
          fontSize: "11px",
        },
      }}
    />
  );
}

export const toast = {
  success: (message: string) =>
    sonnerToast.success(message, { duration: 5000 }),
  error: (message: string) =>
    sonnerToast.error(message, { duration: Infinity }),
  warning: (message: string) =>
    sonnerToast.warning(message, { duration: 5000 }),
  info: (message: string) => sonnerToast.info(message, { duration: 5000 }),
  loading: (message: string) => sonnerToast.loading(message),
  dismiss: (id?: string | number) => sonnerToast.dismiss(id),
};
